import { DefinitionTemplate } from '../Events/components/hooks/useCreateEvent';

export function processFlowTemplate(
    values: Record<string, any>,
    template: DefinitionTemplate,
) {
    const definition = template.definitionJsonString;
    const parsedDefinition = JSON.parse(definition);

    for (const [key, value] of Object.entries(values)) {
        parsedDefinition.templateValues[key].value =
            value || parsedDefinition.templateValues[key].defaultValue;
    }
    const flow = JSON.stringify(parsedDefinition);
    console.log(flow);
    return flow;
}

export function processExperienceTemplate(
    values: Record<string, any>,
    template: DefinitionTemplate,
) {
    const definition = template.definitionJsonString;
    const parsedDefinition = JSON.parse(definition);

    for (const [key, value] of Object.entries(values)) {
        parsedDefinition.templateValues[key].value =
            value || parsedDefinition.templateValues[key].defaultValue;
    }
    const experience = JSON.stringify(parsedDefinition);
    console.log(experience);
    return experience;
}
